<template>
    <div class="homeindex">
        <div class="bg">
            <img src="../../assets/house.png">
        </div>
        <div class="b1">
            <div class="company">公司简介</div>
            <div class="text lst">科融万户是一家以数据驱动决策的互联网科技公司，是一家综合性服务的公司，用创新的产品深度赋能产业，从而不断提升用户的生活品质。</div>
            <div class="text">“科融”寓意着科技创新的融合，“万户”则表示服务的广泛性和普及性，因此“科融万户”的公司名字意味着通过科技的创新与融合，服务于广大人民群众，推动科技的普及与应用，让科技赋能万户，造福社会。
            </div>
            <div class="text">
                科通万户创建的房东直租无中介费租房平台众享租房，让租客能够直接找到真正的房东进行租房，让租客省下非必要的中介费，让租客租房更加的方便便捷，只需要定位位置即可查看附近的房源信息，也让房东的房源信息能够大概率的暴露给租客查阅，提高房东房源出租的成功率，依托行业领先的大数据处理能力，为租客推送心仪的房源信息。
            </div>
            <div class="text">
                科融万户核心团队均来自一线互联网企业阿里巴巴、银行等世界500强企业，深耕互联网、信息安全、金融、电商、银行等行业十余年，在大数据应用、大数据风控、人工智能、互联网运营等领域拥有的成熟且成功的经验，具备强劲实力与市场竞争力。
            </div>
            <div class="text lst">公司始终坚持“互联网+科技+行业、让生活更便捷，一点点！”的服务宗旨，致力于让数据驱动决策、赋能产业。</div>
            <div class="text lst">使命——让生活更便捷，一点点！</div>
            <div class="text lst">愿景——一家受人尊敬的企业</div>
            <div class="text lst">核心价值观——相信、包容、担当、求真、极致、用户第一</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {}
    },
    components: {},
    methods: {}
}
</script>

<style lang="scss" scoped>
.homeindex {
    display: flex;
    justify-content: flex-start;
    .bg{
        img{
            width: 623px;
        }
    }
    .b1 {
        // padding-left: 320px;
        padding-right: 220px;
        box-sizing: border-box;

        .company {
            color: #3BBAD3;
            font-size: 24px;
        }

        .text {
            color: #676A6C;
            padding: 8px 0;
            text-indent: 29px;
            font-size: 22px;
            &.lst {
                text-indent: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/home/index.vue